import githubLogo from 'images/icons-social/github-logo.svg';
import linkedinLogo from 'images/icons-social/linkedin-logo.svg';
import facebookLogo from 'images/icons-social/facebook-logo.svg';
import twitterLogo from 'images/icons-social/twitter-logo.svg';


const listSocial = [{
  icon: githubLogo,
  name: 'github',
  path: 'https://github.com/iteriodata'
}, {
  icon: linkedinLogo,
  name: 'linkedin',
  path: 'https://www.linkedin.com/company/17896542/'
}, {
  icon: facebookLogo,
  name: 'facebook',
  path: 'https://business.facebook.com/Iterio-Data-1499946250088145/'
}, {
  icon: twitterLogo,
  name: 'twitter',
  path: 'https://twitter.com/iteriodata'
}];

export default listSocial;



// WEBPACK FOOTER //
// ./src/components/common/socialIcons/listSocial.js